import { RoleCodeEnum } from '@lon/shared/requests';
import {useAuth} from "@lon/mathnation-suit/hooks";

const dashboardRoles = [
  RoleCodeEnum.DistrictAdmin,
  RoleCodeEnum.SchoolAdmin,
  RoleCodeEnum.Teacher
];

const getHighestRoleWithReportAccess = (): string => {
  const [{ user }] = useAuth();
  const roles = user.userRoles;

  let highestRole = RoleCodeEnum.Teacher;
  if (roles) {
    for (const role of roles) {
      if (role.code === RoleCodeEnum.DistrictAdmin) {
        highestRole = RoleCodeEnum.DistrictAdmin;
      } else if (role.code === RoleCodeEnum.SchoolAdmin) {
        highestRole = RoleCodeEnum.SchoolAdmin;
      }
    }
  }

  return highestRole;
}

export default getHighestRoleWithReportAccess;
